import React from 'react'
import './Section5.css'
import photo1 from './scope.png'
import photo2 from './engagement.png'
import photo3 from './KPI.png'
import photo4 from './ESG.png'
import photo5 from './Climate.png'

const Section5 = () => {
  return (
    <div className='section5'>
      <div className="problem-tag">🔥 BENEFITS</div>
      <h2>
        Why <span className="highlight">EcoIndex</span><br /> for Your Company?
      </h2>

      <div className="benefit-grid">
        <div className="benefit-box benefit-yellow">
          <h3>Scope 3</h3>
          <p>Emission Tracking</p>
          <img src={photo1} alt="Scope 3" className="img-scope3" />
        </div>
        <div className="benefit-box benefit-blue">
          <h3>Employee</h3>
          <p>Engagement System</p>
          <img src={photo2} alt="Engagement" className="img-engagement" />
        </div>
        <div className="benefit-box benefit-green">
          <h3>Tangible</h3>
          <p>Measurable KPIs</p>
          <img src={photo3} alt="KPIs"  className="img-kpis"/>
        </div>
        <div className="benefit-box benefit-purple">
          <h3>Real Action</h3>
          <p>Real ESG Impact</p>
          <img src={photo4} alt="ESG" className="img-esg"  />
        </div>
        <div className="benefit-box benefit-lightgreen">
          <h3>Company-wide</h3>
          <p>Climate Culture</p>
          <img src={photo5} alt="Climate Culture"className="img-climate" />
        </div>
      </div>
    </div>
  )
}

export default Section5
